export const NAVIGATE_TO_ROOT = ['/'];
